(function() {
    'use strict';

    angular
        .module('liverunApp')
        .controller('MedalBoardDetailController', MedalBoardDetailController);

    MedalBoardDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'MedalBoard', 'Race', 'Runner', 'Medal'];

    function MedalBoardDetailController($scope, $rootScope, $stateParams, previousState, entity, MedalBoard, Race, Runner, Medal) {
        var vm = this;

        vm.medalBoard = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('liverunApp:medalBoardUpdate', function(event, result) {
            vm.medalBoard = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
